<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="text"
    track-by="value"
    :options="options"
    :searchable="false"
    :disabled="!editable"
    :allow-empty="false">
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
export default {
  name: 'UserActiveInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      options: [
        { value: 1, text: this.$t('common.Both') },
        { value: 2, text: this.$t('common.ActiveUser') },
        { value: 3, text: this.$t('common.InactiveUser') }
      ]
    };
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 1);
        return (
          this.options.filter((x) => x.value === this.value)
          || this.options.filter((x) => x.value === 1)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.value);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
